import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-header',
  imports: [RouterModule],
  templateUrl: './header.component.html',
  styleUrl: './header.component.css'
})
export class HeaderComponent {
  isMenuOpen: boolean = false;

  toggleDropdown(): void {
    this.isMenuOpen = !this.isMenuOpen;
  }

  closeMenu(button?: HTMLButtonElement): void {
    if (!this.isMenuOpen) {
      return;
    }

    this.isMenuOpen = false;
    button?.focus();
  }
}
